export default {
  af: 'Afghanistan',
  eg: 'Ägypten',
  ar: 'Argentinien',
  az: 'Aserbaidschan',
  et: 'Äthiopien',
  au: 'Australien',
  be: 'Belgien',
  bo: 'Bolivien',
  ba: 'Bosnien und Herzegowina',
  br: 'Brasilien',
  bg: 'Bulgarien',
  bf: 'Burkina Faso',
  cl: 'Chile',
  cn: 'China',
  cr: 'Costa Rica',
  dk: 'Dänemark',
  de: 'Deutschland',
  ec: 'Ecuador',
  gb: 'Vereinigtes Königreich',
  fr: 'Frankreich',
  ge: 'Georgien',
  gh: 'Ghana',
  gr: 'Griechenland',
  in: 'Indien',
  id: 'Indonesien',
  ir: 'Iran',
  il: 'Israel',
  it: 'Italien',
  jp: 'Japan',
  kh: 'Kambodscha',
  ca: 'Kanada',
  co: 'Kolumbien',
  hr: 'Kroatien',
  mg: 'Madagaskar',
  ma: 'Marokko',
  mk: 'Nordmazedonien',
  mx: 'Mexiko',
  md: 'Moldau',
  nz: 'Neuseeland',
  nl: 'Niederlande',
  ne: 'Niger',
  ng: 'Nigeria',
  at: 'Österreich',
  pk: 'Pakistan',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippinen',
  pl: 'Polen',
  pt: 'Portugal',
  ro: 'Rumänien',
  ru: 'Russland',
  as: 'Amerikanisch-Samoa',
  sa: 'Saudi-Arabien',
  se: 'Schweden',
  rs: 'Serbien',
  sl: 'Sierra Leone',
  es: 'Spanien',
  lk: 'Sri Lanka',
  za: 'Südafrika',
  ug: 'Uganda',
  th: 'Thailand',
  cz: 'Tschechien',
  tn: 'Tunesien',
  tr: 'Türkei',
  ua: 'Ukraine',
  hu: 'Ungarn',
  us: 'Vereinigte Staaten',
  uz: 'Usbekistan',
  vn: 'Vietnam',
};
